import semver from "semver";
import { TILE_EVENTS_VERSION as runtimeVersion } from "@narmi/tile-events";

export const checkVersion = (tileVersion: string) => {
  if (!semver.valid(tileVersion)) {
    return false;
  }
  return (
    semver.major(tileVersion) === semver.major(runtimeVersion) &&
    semver.lte(tileVersion, runtimeVersion)
  );
};

export const isAllowedNavigation = (
  request: { url: string; isTopFrame: boolean },
  tileOrigin: string
) => {
  if (!request.isTopFrame) {
    return true;
  }
  try {
    return new URL(request.url).origin === tileOrigin;
  } catch {
    return false;
  }
};
